module.exports = __webpack_public_path__ + "img/Customs-clearance1.9395adb0.jpg";